import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { LogglyLoggerService } from 'kolektor-services'
@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private loggerService: LogglyLoggerService) { }

  handleError(error) {

    if (error instanceof HttpErrorResponse) {

      this.loggerService.send({
        type: 'HttpErrorResponse',
        error: error
      });
    } else if (error instanceof TypeError) {

      this.loggerService.send({
        type: 'TypeError',
        message: error.message,
        stack: error.stack
      });
    } else if (error instanceof Error) {

      this.loggerService.send({
        type: 'Error',
        message: error.message,
        stack: error.stack
      });
    } else {

      this.loggerService.send({
        type: 'UnhandledError',
        error: error
      })
    }

    // TODO: Redirect to error page and remove throw error.
    throw error;
    // this.router.navigateByUrl('error');

  }
}
